module.exports = __webpack_public_path__ + "static/img/cert2.b5d2917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert2.png
// module id = XASX
// module chunks = 1